import React from 'react';
import { useParams } from 'react-router-dom';
import {
  HistoryEduOutlined,
  RateReviewOutlined,
  SupervisorAccountOutlined,
  Approval,
  AssignmentInd,
} from '@mui/icons-material';
import { PAGE_TEXT } from '../../lang';
import { NominationModules } from '../../../constants';
import { Sidebar, type SidebarData, Button } from '../../../../../components';
import { SidebarViewPoint } from '../../../../Application/components';

export type NominationSidebarProps = {
  onChangeActivated: (activatedId: NominationModules) => void;
  onSubmitNomination: () => void;
  isUPAF: boolean;
  currentActivatedModule: string;
  sidebarDisabled: boolean;
  hasNominationId: boolean;
};

const disableEvaluationTip = PAGE_TEXT.DISABLE_EVALUATION_TIP;
export const NominationSidebar: React.FunctionComponent<
  NominationSidebarProps
> = props => {
  const { nominationId: id } = useParams();
  const hasNominationId = Boolean(id);

  const {
    currentActivatedModule,
    isUPAF,
    onChangeActivated,
    onSubmitNomination,
    sidebarDisabled,
  } = props;

  const sidebarData: SidebarData[] = [
    {
      id: NominationModules.SUPERVISORS,
      name: PAGE_TEXT.CHIEF_SUPERVISOR.TITLE,
      icon: <SupervisorAccountOutlined />,
      children: [
        {
          id: NominationModules.CHIEF_SUPERVISOR,
          name: PAGE_TEXT.CHIEF_SUPERVISOR.CHIEF_SUPERVISOR.TITLE,
        },
        {
          id: NominationModules.SUPERVISOR_TEAM,
          disabled: sidebarDisabled,
          name: PAGE_TEXT.SUPERVISOR_TEAM.TITLE,
        },
      ],
    },
    {
      id: NominationModules.FORM,
      name: PAGE_TEXT.GSB1_FORM.TITLE,
      disabled: sidebarDisabled,
      icon: <AssignmentInd />,
    },

    {
      id: NominationModules.SCHOLARSHIP_NOMINATION,
      name: PAGE_TEXT.SCHOLARSHIP_NOMINATION,
      disabled: sidebarDisabled,
      icon: <Approval />,
      children: [
        {
          id: NominationModules.FUNDINGS,
          name: PAGE_TEXT.FUNDING.TITLE,
          disabled: sidebarDisabled,
        },
        {
          id: NominationModules.EVALUATION,
          disabled: sidebarDisabled || !isUPAF,
          name: PAGE_TEXT.EVALUATION.TITLE,
          hoverText:
            !isUPAF && !sidebarDisabled ? disableEvaluationTip : undefined,
        },
      ],
    },

    {
      id: NominationModules.DECLARATION,
      name: PAGE_TEXT.DECLARATION.TITLE,
      disabled: sidebarDisabled,
      icon: <HistoryEduOutlined />,
    },
    {
      id: NominationModules.REMARKS,
      name: PAGE_TEXT.REMARKS.TITLE,
      disabled: sidebarDisabled,
      icon: <RateReviewOutlined />,
    },
  ];

  const handleChangeActivated = (activatedId: string): void => {
    onChangeActivated(activatedId as NominationModules);
  };

  const handleBack = (): void => {
    window.location.href = `/internal/nominations/application-list`;
  };

  return (
    <SidebarViewPoint>
      <Sidebar
        defaultActivatedId={NominationModules.CHIEF_SUPERVISOR}
        sidebarData={sidebarData}
        barInnerWidth="16rem"
        manuallyActivatedId={currentActivatedModule}
        onChangeActivated={handleChangeActivated}
      />
      <div className="flex flex-col justify-center items-center mt-6 gap-4 w-full">
        <Button variant="outlined" onClick={handleBack} className="w-[100px]">
          {PAGE_TEXT.BACK}
        </Button>
        {/* if has not been accepted, should not show the submit button */}
        {!sidebarDisabled && (
          <Button
            className={`${hasNominationId ? '' : 'hidden'} w-[100px]`}
            variant="contained"
            onClick={onSubmitNomination}
          >
            {PAGE_TEXT.SUBMIT}
          </Button>
        )}
      </div>
    </SidebarViewPoint>
  );
};
